import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { INgayNghiActionTypes } from "../../action-types/danh-muc/INgayNghiActionTypes";
import { INgayNghiReducer } from "../../page-state-model/danh-muc/INgayNghiReducer";
const iniState: INgayNghiReducer = {
    status: ePageBaseStatus.is_not_initialization,
    ngayNghis: []
}
export const ngayNghiReducer = (state: INgayNghiReducer = iniState, action: INgayNghiActionTypes): INgayNghiReducer => {
    switch (action.type) {
        case "NGAY_NGHI_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "NGAY_NGHI_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: action.payload
            }
        case "NGAY_NGHI_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: []
            }
        case "NGAY_NGHI_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "NGAY_NGHI_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: action.payload
            }
        case "NGAY_NGHI_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: []
            }
        case "NGAY_NGHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "NGAY_NGHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "NGAY_NGHI_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "NGAY_NGHI_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "NGAY_NGHI_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "NGAY_NGHI_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "NGAY_NGHI_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "NGAY_NGHI_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}